import { useAuth } from '@/contexts/AuthContext';

/**
 * Thin convenience hook over the workgroup membership data AuthContext already
 * holds (loaded at login/refresh/switch time). No separate network call —
 * `AuthContext.workgroups`/`activeWorkgroupId` are already kept fresh, and
 * `switchWorkgroup` already re-persists tokens and reloads session data.
 */
export function useWorkgroups() {
  const { workgroups, activeWorkgroupId, workgroupEpoch, switchWorkgroup } = useAuth();

  const activeWorkgroup = workgroups.find((wg) => wg.id === activeWorkgroupId) || null;

  return {
    workgroups,
    activeWorkgroupId,
    activeWorkgroup,
    workgroupEpoch,
    switchWorkgroup,
  };
}

export default useWorkgroups;
